import './content-wrapper.scss';

/**
 * version    1.0
 * class      <type> (content wrapper)
 * classdesc  This is a wrapper class for content sections
 */
export class ContentWrapper {}
